<div class="dropdown" >
    <div class="dropdown-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div>
        <div class="dropdown-heading">Display Settings
        </div>
      </div>
    </div>
    <div class="dropdown-content">
      <div class="notification" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="auto">
          <div class="notification-label">User Provided Values</div>
        </div>
        <mat-slide-toggle (change)="onToggleUserProvider($event)"  color="primary" [checked]="isShowUserProvider"></mat-slide-toggle>
      </div>
      <div class="notification" fxLayout="row" fxLayoutAlign="start center" *ngIf="callFrom !== 'PreviewIPPool'">
        <div fxFlex="auto">
          <div class="notification-label">Service Provided Values</div>
        </div>
        <mat-slide-toggle (change)="onToggleServiceProvider($event)"  color="primary" [checked]="isShowServiceProvider"></mat-slide-toggle>
      </div>
      <div class="notification" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="auto">
          <div class="notification-label">Null Values</div>
        </div>
        <mat-slide-toggle (change)="onToggleNullValues($event)"  color="primary" [checked]="isShowNullValues"></mat-slide-toggle>
      </div>
      <div *ngIf="isShowAuditToggle" class="notification" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="auto">
          <div class="notification-label">Audit</div>
        </div>
        <mat-slide-toggle (change)="onToggleAuditValues($event)"  color="primary" [checked]="isShowAudit"></mat-slide-toggle>
      </div>
    </div>
    <div class="dropdown-footer" fxLayout="row" fxLayoutAlign="space-between start">
      <a (click)="onReset()" color="warn" mat-button >Reset</a>
      <a (click)="onApplyChanges()" color="primary" mat-button>Apply</a>
    </div>
</div>
  
  